// extracted by mini-css-extract-plugin
module.exports =  {"icon":"dkkz1om","container":"Y02fMah","content":"oKt_nLo"};